import { metaEnv } from 'utils/metaEnv';
import { useMetadataContext } from 'utils/contexts/MetadataContext';

export const useVersionData = () => {
    const metadata = useMetadataContext();

    const versionInfo = metadata
        ? `${metaEnv.VITE_UI_VERSION || metaEnv.VITE_HEAD_COMMIT} - ${
              metadata.version
          } - ${metadata.schema_version}`
        : '';

    return { versionInfo };
};
